import { render } from "./SignFile.vue?vue&type=template&id=57cbef2e"
import script from "./SignFile.vue?vue&type=script&lang=js"
export * from "./SignFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__